import DfspConfig from './DfspConfig';
import * as selectors from './selectors';

export default DfspConfig;
export { selectors };
